import SsnValidationErrorBanner from './SsnValidationErrorBanner';

export default SsnValidationErrorBanner;
